import angular from 'angular';

import Trees from '../../models/trees';
import FactQuery from '../../models/fact-query';
import AnalyticsServ from '../../services/analytics';

import lfFilterTree from '../lf-filter-tree';
import fbListFilter from '../../components/fb-list-filter';

import FilterListDirective from './filter-list.directive';

export default angular.module('directives.lf-filter-list', [
    lfFilterTree,
    fbListFilter,
    FactQuery,
    Trees,
    AnalyticsServ
  ])
  .directive('lfFilterList', FilterListDirective)
  .name;



// WEBPACK FOOTER //
// ./project/directives/lf-filter-list/index.js